import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as i18n from "../i18n.ts";
import * as CustomInput from "../util/CustomInput.ts";
import { markInvalidNative } from "../util/forms.ts";
import {getCache} from "../server/objects/BudgetBeans.ts";
import * as segment from "../tracking-segment.ts";
export {initDom}

const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();

Html.registerWidget('budget/widget-transactionline',{initDom})

function getTransaction(metaId){
  var transaction = budgetTransactionCache.get(metaId)
  if(transaction===null){
    metaId = metaId.substring(0,metaId.lastIndexOf('_'));
    transaction = budgetTransactionCache.get(metaId)
  }
  return transaction;
}


actionMenu.register({
  budgetpickcategory:function(){
    var
      metaId = Html.getDomMetaId(this),
      transaction = getTransaction(metaId),
      catMenuBuilder = cat=>{
        return {
          emoji:cat.emoji,
          title:cat.name,
          onclick:"budgetpickedcategory|"+metaId+"|"+cat.metaId,
          selected:cat.metaId===transaction.budgetCategoryId
        }
      },
      categories = budgetCategoryCache.filtered(),
      menu = [{i18nkey:"budget.expense"}]
        .concat(categories.filter(cat=>cat.budgetTransactionType==="EXPENSE").map(catMenuBuilder))
        .concat([{i18nkey:"budget.revenue"}])
        .concat(categories.filter(cat=>cat.budgetTransactionType==="REVENUE").map(catMenuBuilder));

    return {
      menu:menu
    }
  },
  budgetpickpaymentmethod:function(){
    var
      metaId = Html.getDomMetaId(this),
      transaction = getTransaction(metaId);
    return {
      menu:budgetPaymentMethodCache.filtered().map(cat=>{
        return {
          emoji:cat.emoji,
          title:cat.name,
          onclick:"budgetpickedpaymentmethod|"+metaId+"|"+cat.metaId
        }
      })
    }
  },
  budgetpickaccount:function(){
    var
      metaId = Html.getDomMetaId(this),
      transaction = getTransaction(metaId),
      accountmenu = FwDatas.getFamily().members.map(member=>{
        return {
          img: member.thumb(),
          iconclass:"rounded",
          title:member.firstName,
          onclick:"budgetpickedaccount|"+metaId+"|"+member.accountId
        }
      });
    return {menu:accountmenu}

  }
})
Html.registerDom({
  budgetpickedcategory(transactionId,budgetCategoryId){
    var cat = budgetCategoryCache.get(budgetCategoryId)
    checkUpdateOption({budgetCategoryId:budgetCategoryId,budgetTransactionType:cat.budgetTransactionType,metaId:transactionId})
  },
  budgetpickedpaymentmethod(transactionId,paymentMethodId){
    checkUpdateOption({paymentMethodId:paymentMethodId,metaId:transactionId})
  },
  budgetpickedaccount(transactionId,relatedAccountId){
    checkUpdateOption({relatedAccountId:relatedAccountId,metaId:transactionId})
  }
})
function initDom(trNode: HTMLElement){
  const metaId = Html.getDomMetaId(trNode);

  trNode.addEventListener('keypress',function(event: KeyboardEvent){
    if(event.keyCode===10 || event.keyCode===13){
      event.preventDefault();
      (event.target as HTMLElement).blur();
    }
  });

  trNode.querySelectorAll('[data-name], input').forEach(element => {
    element.addEventListener('blur',function(){
      const node = this as HTMLInputElement;
      const data: any = {metaId:metaId};

      if(node.getAttribute('type')==='amount'){
        let value = Math.abs(CustomInput.getAmountValue(node));
        if(isNaN(value)||value===0){
          markInvalidNative(node, i18n.get('budget.transactionerrors.amount'));
          return;
        }
        data[node.getAttribute('name')] = value;
      }else if(node.getAttribute('type')==='date'){
        let
          value = CustomInput.getDateValue(node),
          original = getTransaction(metaId).startDate;

        value = new Date(value.toISOString().substring(0,10)+original.toISOString().substring(10));

        data[node.getAttribute('name')] = value;
      }else if(node.getAttribute('type')==='text'){
        data[node.getAttribute('name')] = node.value;
      }
      checkUpdateOption(data);
    });
  });

  trNode.querySelectorAll('[data-name]').forEach(element => {
    element.addEventListener('paste',function(){
      setTimeout(()=>{
        (this as HTMLElement).innerHTML = (this as HTMLElement).innerText;
      }, 10);
    });
  });

  trNode.querySelectorAll('input').forEach(input => {
    input.addEventListener('focus',function(){
      (this as HTMLInputElement).select();
    });
  });
}


function checkUpdateOption(data){
  var
    transactionToUpdate = getTransaction(data.metaId),
    worthDoingSomething = false;
  //check if something changed
  for(var name in data){
    if(name==='metaId') continue;
    var d = data[name],t= transactionToUpdate[name];
    if(d instanceof Date && t instanceof Date){
      if(d.getTime()!=t.getTime()){
        worthDoingSomething = true;
        break;
      }
    }else if(d!=t){
      worthDoingSomething = true;
      break;
    }
  }
  if(!worthDoingSomething) return;

  if(transactionToUpdate.recurrencyDescriptor.recurrency==="NONE"){
    doitWithOption(data,"All")
    return;
  }
  ApiServer.budgettransactionupdateoption(data,function(options){
    if(options.length<2){
      doitWithOption(data,options[0])
    }else{
      modal.ask({
        title:'budget.updaterecurringtitle',
        message:'budget.updaterecurringtext',
        button:options.map(opt=>{return {value:opt,title:'budget.updaterecurring'+opt}})
      },function(opt){
        if(opt) doitWithOption(data,opt)
      });
    }
  })
}

function doitWithOption(data,option){
  //an inline edit only sends the edited fields
  ApiServer.budgettransactionput.prepare(option)(data,function(){
    segment.track("Budget Transaction Edited",{field_changed:Object.keys(data).filter(key=>key!=='metaId').join(',')});
  })
}
